module.exports = __webpack_public_path__ + "static/media/logo_cadcti.ea78896e.svg";